import { Badge } from "@/components/ui/badge";
import { getCurrentParticipant } from "@/features/participants/api/get-current-participant";
import { useDraggable } from "@dnd-kit/core";

import { ParticipantWithSessionId } from "../types/participant-with-session-id";

export function BreakoutSessionParticipant({
  participant,
}: {
  participant: ParticipantWithSessionId;
}) {
  const currentParticipant = getCurrentParticipant();
  const isCurrentParticipant =
    currentParticipant?.participantId === participant.participantId;

  const { attributes, listeners, setNodeRef, transform } = useDraggable({
    id: participant.participantId,
    // dont let drag yourself, you need to click on Join button instead
    disabled: isCurrentParticipant,
  });

  const style = transform
    ? {
        transform: `translate3d(${transform.x}px, ${transform.y}px, 0)`,
      }
    : undefined;

  return (
    <Badge
      variant="outline"
      className="cursor-move px-2 py-1.5"
      ref={setNodeRef}
      style={style}
      {...listeners}
      {...attributes}
    >
      {participant.name} {isCurrentParticipant && "(You)"}
    </Badge>
  );
}
